import types from './types';

export const setIsAcceptGdpr = isAcceptGdpr => {
  return {
    type: types.SET_IS_ACCEPT_GDPR,
    isAcceptGdpr,
  };
};
